import React from 'react'
import Manager from '../../public/components/Manager'
import ObjectionDeductionDiv from './ObjectionDeductionDiv'
import BachConfirmDiv from './BachConfirmDiv'
Ext.require('Ext.Toast')

const handelBatchAction = ({ showDetail, refreshPage, state: { selected }, props: { dispatch } }) => {
    const list = selected && selected.map(o => o.data.id) || []
    Tyan.pubForm.showDialog('批量确认', props => <BachConfirmDiv {...props} ids={list} onSave={refreshPage} />)
}
const disableBatch = ({ state: { selected = null } }) => !selected || !selected.length
const config = {
    tabs:
    {
        待确认: {
            multiSelect: true,
            buttons: [
                {
                    text: '确认', handler: that => handelBatchAction(that), disabled: disableBatch
                },
            ],
            columns: [
                { _text: '发放月份', field: 'SalaryApply.Issue', minWidth: 250, search: true, },
                { _text: '员工编号', field: '_PersonNo', minWidth: 150, },
                { _text: '员工姓名', field: 'PersonName', minWidth: 150, flex: 10, search: true },
                { _text: '科目代码', minWidth: 150, flex: 10, search: true },
                { _text: '科目名称', minWidth: 150, search: true, },
                { _float: '加扣金额（元）', field: 'Amount', minWidth: 150, filter: true, },
                { _: 'taskName', field: '_TaskName' },
                {
                    _button: '确认...', locked: 'right', icon: 'edit', minWidth: 120, handler: ({ showDetail, refreshPage }, data) => {
                        Tyan.pubForm.showDialog('加扣项', props => <ObjectionDeductionDiv {...props} id={data.id} onFlowFinished={refreshPage} taskName={data.taskName} />)
                    }, hidden: data => data.员工姓名 != Tyan.loginInfo.userName
                },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                // showDetail(props => <LeaveApplyDetail {...props} id={data.id} />)
            }
        },
        已确认: {
            buttons: [
            ],
            columns: [
                { _text: '发放月份', field: 'SalaryApply.Issue', minWidth: 250, search: true, },
                { _text: '员工编号', field: '_PersonNo', minWidth: 150, },
                { _text: '员工姓名', field: 'PersonName', minWidth: 150, flex: 10, search: true },
                { _text: '科目代码', minWidth: 150, flex: 10, search: true },
                { _text: '科目名称', minWidth: 150, search: true, },
                { _float: '加扣金额（元）', field: 'Amount', minWidth: 150, filter: true, },
            ],
            onDoubleTap: ({ showDetail, refreshPage }, data) => {
                // showDetail(props => <LeaveApplyDetail {...props} id={data.id} />)
            }
        }
    }
}

export default props => <Manager {...props} config={config} />